import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const BKJEllipsisMenuUIStateContext = createContext({
    isOpen: false,
    openMenu: () => void 0,
    closeMenu: () => void 0,
    toggleMenu: () => void 0,
});
export const BKJEllipsisMenuUIStateProvider = ({ children }) => {
    const [isOpen, setOpen] = useState(false);
    const openMenu = useCallback(() => {
        setOpen(true);
        return void 0;
    }, []);
    const closeMenu = useCallback(() => {
        setOpen(false);
        return void 0;
    }, []);
    const toggleMenu = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        setOpen(!isOpen);
        return void 0;
    }, [isOpen]);
    const contextValue = useMemo(() => ({
        isOpen,
        openMenu,
        closeMenu,
        toggleMenu,
    }), [closeMenu, isOpen, openMenu, toggleMenu]);
    return (_jsx(BKJEllipsisMenuUIStateContext.Provider, { value: contextValue, children: children }));
};
export const useBKJEllipsisMenuUIStateContext = () => useContext(BKJEllipsisMenuUIStateContext);
//# sourceMappingURL=BKJEllipsisMenu.context.js.map